'use client';
import { StreamingUnactivated } from './streaming-unactived';
import { useAccountInfo } from '@/hooks/query/account';
import { SportMatchModel } from '@nf/types/odds';
import { CloudRockStreaming, DefaultStreaming, GameVisualization, InHouseStreaming, Streamer21Streaming, StreamerMCDNStreaming } from '.';
import { useStreamingStore } from '@/store/streaming';
import { IframeStreaming } from './streaming-iframe';
import { VideoDeviceType } from '@/services/streaming.service';
import { EsportVideo } from './streaming-esport';
import { StreamerPlugin } from './streaming-plugin';

export const StreamingControl = ({ match, device, isStreamingPlugin, streamingPluginType }: { match: SportMatchModel, device: VideoDeviceType, isStreamingPlugin?: boolean, streamingPluginType?: number }) => {
	const Streamer21List = ['21', '22', '23', '29'];
	const MCDNStreamerList = ['24', '25', '26', '27', '28'];
	const OtherSportList = ['17', '18'];
	const { user } = useAccountInfo();
	const { MatchId } = match ?? {};
	const [
		streamingType, 
		streamingSrc, 
		channelList, 
		isEsport
	] = useStreamingStore(
		state => [
			state.streamingType, 
			state.streamingSrc, 
			state.channelList, 
			state.isEsport
		],
	);

	if (user?.ActStatus !== 2) {
		return (
			<StreamingUnactivated type="2" />
		);
	} else if (isStreamingPlugin) {
		return (
			<StreamerPlugin
				match={match}
				streamingPluginType={streamingPluginType || 0}
			/>
		);
	} else if (streamingType !== 'StaticInfo' && !streamingSrc && streamingType !== 'GV' && !isEsport) {
		return null;
	} else if (channelList.find((channel) => channel.value.indexOf(streamingSrc) > -1)?.fixing && !isEsport) {
		return (
			<StreamingUnactivated type="6" />
		);
	}

	switch (streamingType) {
		case 'Streamer':
			if (MCDNStreamerList.indexOf(streamingSrc.split('-')[0]) > -1) {
				return (
					<StreamerMCDNStreaming match={match} device={device} streamerRewardId={user?.RewardInfo?.StreamerRewardId} />
				);
			} else {
				return (
					Streamer21List.indexOf(streamingSrc.split('-')[0]) > -1 ?
						<Streamer21Streaming match={match} device={device} streamerRewardId={user?.RewardInfo?.StreamerRewardId} /> : <CloudRockStreaming match={match} device={device} streamerRewardId={user?.RewardInfo?.StreamerRewardId} />
				);
			}

		case 'Streaming':
			if (match.GameID === 43 && isEsport) {
				return <EsportVideo match={match} device={device} />;
			}
			return (
				OtherSportList.indexOf(streamingSrc) > -1 ?
					<IframeStreaming match={match} /> :
					(
						(streamingSrc === '13' || streamingSrc.startsWith('13-')) ? <InHouseStreaming matchId={MatchId ?? 0} device={device} /> :
							(
								streamingSrc === '19' ?
									<CloudRockStreaming match={match} device={device} /> : <DefaultStreaming match={match} />
							)
					)
			);
		case 'StaticInfo':
			return <IframeStreaming match={match} />;
		default:
			return <GameVisualization match={match} />;
	}
};


